import React, { useEffect, useState } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';

const DropDownNew = ({
  name,
  label,
  options = [],
  labelField = 'label',
  valueField = 'value',
  control,
  helperText,
  error = false,
  fullWidth = true,
  preSelectedValue = '',
  rules = {},
  includeEmptyOption = false,
  emptyOptionLabel = 'Seleccione...',
  size = 'small',
  margin = 'dense',
  variant = 'outlined',
  disabled = false,
  onChange: customOnChange = () => {},
}) => {
  const { setValue } = useFormContext();
  const [dropDownOptions, setDropDownOptions] = useState(options);

  useEffect(() => {
    setDropDownOptions(options);
  }, [options]);

  useEffect(() => {
    if (preSelectedValue) {
      setValue(name, preSelectedValue);
    }
  }, [preSelectedValue, name, setValue]);

  return (
    <FormControl
      variant={variant}
      fullWidth={fullWidth}
      error={error}
      margin={margin}
      size={size}
      disabled={disabled}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={preSelectedValue || ''}
        rules={rules}
        render={({ field }) => (
          <Select
            {...field}
            labelId={`${name}-label`}
            id={`${name}-select`}
            label={label}
            onChange={(e) => {
              const value = e.target.value;
              field.onChange(value);
              customOnChange(value);
            }}
            onBlur={field.onBlur}
            disabled={disabled}
          >
            {includeEmptyOption && (
              <MenuItem value="">
                <em>{emptyOptionLabel}</em>
              </MenuItem>
            )}
            {dropDownOptions.map((option, index) => (
              <MenuItem key={index} value={option[valueField]}>
                {option[labelField]}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default DropDownNew;
